import React from "react";
import fieldPropTypes from "../field-prop-types";

const ModernizedIconButton = ({
  field: {
    name,
    params,
    text,
    action,
    disabled,
    icon,
    size,
    buttonType,
    accessibility
  },
  components: { ModernizedIconButton: IconButton },
  appData: { handleBackButtonClick, handleButtonClick }
}) => {
  const iconButtonClassName = `${name} ${
    params ? params.split("|").join(" ") : ""
  }`;
  const handleClick = () =>
    action?.type === "pop_screen"
      ? handleBackButtonClick()
      : handleButtonClick(name, text, action);
  const ariaProps = {
    title: accessibility?.label,
    "aria-label": accessibility?.label
  };

  if (accessibility?.role) {
    ariaProps.role = accessibility?.role;
  }

  return (
    <IconButton
      className={iconButtonClassName}
      disabled={disabled}
      icon={icon}
      onClick={handleClick}
      size={size}
      type={buttonType}
      {...ariaProps}
    />
  );
};

ModernizedIconButton.propTypes = fieldPropTypes;

export default ModernizedIconButton;
